'use strict';
const _ = require('lodash');
const Backbone = require('backbone');
const PubSub = require('./../PubSub');
const template = require('../templates/timer.ejs');
const CONST_TIMER = require('../constants').COUNTDOWN;

module.exports = Backbone.View.extend({
    tagName: 'div',
    className: 'view-timer',
    /**
     * Initialize countdown view
     */
    initialize: function (options) {
        _.bindAll(this, 'render');
        this.model = options.model;
        this.copy = {
            labels: {
                singular: CONST_TIMER.SINGULAR,
                plural: CONST_TIMER.PLURAL
            },
            text: options.countdownCopy
        };
        this.displayCountdown = true;

        this.listenTo(this.model, 'change:timerEnded', this.checkTimer.bind(this));
        this.listenTo(this.model, 'change:seconds', this.checkTimer.bind(this));
    },
    /**
     * Render the countdown
     */
    render: function () {
        this.copy.timer = _.clone(this.model.toJSON());
        this.$el.html(template(this.copy));
        return this;
    },
    /**
     * Call after rendering
     */
    renderedToDom: function() {
        this.model.startCountdown();
    },
    /**
     * Check if countdown ended
     */
    checkTimer: function() {

        var date = new Date( new Date().toLocaleString('en-US', { timeZone: 'America/Los_Angeles' } ) );
        this.displayCountdown = date.getTime() < this.model.get('endTimestamp');

        if(!this.model.get('timerEnded') && this.model.get('isResetting') && this.displayCountdown) {
            return this.render();
        }

        // checks if timer is supposed to be reset at 00:00:00 or stop being displayed altogether
        if(this.model.get('timerEnded') && this.model.get('isResetting') && this.displayCountdown) {
            var resetTime = this.copy.text.reset_time;
            var date = new Date();
            var month = date.getMonth() + 1; // January returns 0
            var day = date.getDate() + 1; // Since the reset time has expired, set for the next day
            var nextDay = ('0'+ month).slice(-2) + '/' + ('0' + day).slice(-2) + '/' + date.getFullYear();
            var resetDate = nextDay + ' ' + resetTime;

            PubSub.trigger('resetCategories');

            this.model.set({ endTime: resetDate }, { silent: true });
            this.model.startCountdown();
            this.render();
        } else {
            this.$el.hide();
            this.model.stopCountdown();
            this.stopListening();
        }
    },
    /**
     * Remove the view
     */
    remove: function() {
        this.model.stopCountdown();
        this.stopListening();
        return Backbone.View.prototype.remove.call(this);
    }
});


// WEBPACK FOOTER //
// ./app/scripts/views/timer.js